import React, { useMemo } from 'react';

import { getPageOffset, getCurrentPage } from 'util/pagination';
import AkPagination from '@atlaskit/pagination';
import Select from '@atlaskit/select';
import styled from 'styled-components';
import { messages } from '../messages';
import { FormattedMessage } from 'react-intl';
import { Dimensions } from '../../../components/visuals';

const PagesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Dimensions.units(1)}px;
`;

const PaginationWrappper = styled.div`
  display: flex;
  justify-content: space-between;
`;

type Params = {
  limit?: number;
  offset?: number;
  maxCachedPages?: number;
  latestPageNumber?: number;
};

export type PaginationProps = {
  limit?: number;
  offset?: number;
  hasMoreResults?: boolean | null;
  onPaginationChange: (params: Params) => void;
  maxCachedPages: number;
  latestPageNumber?: number;
};

const OrdersPagination = (props: PaginationProps) => {
  const { limit = 0, offset = 0, onPaginationChange, hasMoreResults } = props;

  const currentPage = getCurrentPage(offset, limit);
  const totalPages = Math.max(
    hasMoreResults ? currentPage + 2 : currentPage + 1,
    props.maxCachedPages,
  );

  const pages = useMemo(() => {
    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    if (props.latestPageNumber === totalPages) {
      return pageNumbers;
    }
    return hasMoreResults ? [...pageNumbers, '...'] : pageNumbers;
  }, [totalPages, hasMoreResults]);

  const handleResultsPerPageChange = (_event) => {
    onPaginationChange({
      limit: _event.value ? _event.value : props.limit,
    });
  };

  const handlePageChange = (_event, newPage) => {
    onPaginationChange({
      maxCachedPages: totalPages,
      latestPageNumber: hasMoreResults === false ? totalPages : props.latestPageNumber,
      offset: getPageOffset(newPage === '...' ? totalPages : newPage, limit),
    });
  };

  return (
    <PaginationWrappper>
      <AkPagination
        defaultSelectedIndex={currentPage}
        selectedIndex={currentPage}
        pages={pages}
        onChange={handlePageChange}
      />
      <PagesWrapper>
        <FormattedMessage {...messages.resultsPerPage} />
        <div>
          <Select
            spacing="compact"
            value={{ label: props.limit?.toString(), value: props.limit }}
            options={[
              { label: '10', value: 10 },
              { label: '15', value: 15 },
              { label: '20', value: 20 },
              { label: '25', value: 25 },
              { label: '30', value: 30 },
              { label: '40', value: 40 },
            ]}
            onChange={handleResultsPerPageChange}
          />
        </div>
      </PagesWrapper>
    </PaginationWrappper>
  );
};

export default OrdersPagination;
